import type { MenuBadgeCounts } from './types/menu-badge'

import { defineApi } from '#/api/define-api'
import { requestClient } from '#/api/request'

export const menuBadgeApi = defineApi('operation', ({ prefix }) => {
  /**
   * 按业务编码查询菜单角标数量。
   * GET /gobestads/operation/badgeCounts
   */
  function queryCounts(): Promise<MenuBadgeCounts> {
    return requestClient.get<MenuBadgeCounts>(prefix('badgeCounts'))
  }

  return { queryCounts }
})
